import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  headerItems: ".blog__heading-inner",
  articleItem: ".blog__article",
  pagination: ".blog__pagination",
};

export default node => {
  if (!shouldAnimate(node)) return;

  delayOffset(node, [
    selectors.headerItems,
    selectors.articleItem,
    selectors.pagination,
  ]);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
